/*
 * Copyright (c) 2018 Barney Boisvert
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import RPTSecret from "prop-types/lib/ReactPropTypesSecret";
import {
    createChainableTypeChecker,
    getClassName,
    PropTypeError,
} from "./typeHelpers";
import LoadObject from "data/LoadObject";

const loadObjectOf = (valueTypeChecker, optionalErrorTypeChecker) =>
    createChainableTypeChecker((
        props,
        propName,
        componentName,
        location,
        propFullName,
    ) => {
        if (typeof valueTypeChecker !== "function" || (optionalErrorTypeChecker != null && typeof optionalErrorTypeChecker !== "function")) {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside loadObjectOf.");
        }
        const lo = props[propName];
        if (!(lo instanceof LoadObject)) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(lo) + "` supplied to `" + componentName + "`, expected instance of `LoadObject`.");
        }
        if (lo.hasValue()) {
            const error = valueTypeChecker(
                {value: lo.getValueEnforcing()},
                "value",
                "LoadObject",
                location,
                propFullName + ".value",
                RPTSecret,
            );
            if (error != null) return error;
        }
        if (optionalErrorTypeChecker != null && lo.hasError()) {
            const error = valueTypeChecker(
                {error: lo.getErrorEnforcing()},
                "error",
                "LoadObject",
                location,
                propFullName + ".error",
                RPTSecret,
            );
            if (error != null) return error;
        }
        return null;
    });

export default loadObjectOf;



// WEBPACK FOOTER //
// ./app/data/util/loadObjectOf.js